export const RoleLevelEnum = {
    GUEST: 0,
    SALEAGENT: 1,
    ADMINAGENT: 2,
    MANAGERAGENT: 3,
    MANAGERNHO: 4,
}